/**
 * Apresentacao dos resultados; as opcoes dos filtros sao fornecidas pela API.
 * @deprecated use types/analise-agnes/GrauExposicaoRisco
 */
export const GRAUS_RISCO = [
  { value: 'CRITICO', label: 'Crítico', color: '#E03131', totalKey: 'critico' },
  { value: 'ELEVADO', label: 'Elevado', color: '#F08C00', totalKey: 'elevado' },
  { value: 'MODERADO', label: 'Moderado', color: '#E4C23F', totalKey: 'moderado' },
  { value: 'BAIXO', label: 'Baixo', color: '#2F9E44', totalKey: 'baixo' },
  { value: 'INEXPRESSIVO', label: 'Inexpressivo', color: '#8189A6', totalKey: 'inexpressivo' },
  { value: 'EM_ANALISE', label: 'Em análise', color: '#4C3D9A', totalKey: 'emAnalise' },
] as const;
